import { useState } from "react";
import { updateOrderSectionURL } from "../../utils/ConstantsURL";

export const useUpdateSectionOrder = (token) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateSectionOrder = async (id_section, new_orden) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(updateOrderSectionURL(), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id_section,
          new_orden,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update section order");
      }
    } catch (err) {
      console.error("Error updating section order:", err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { updateSectionOrder, isLoading, error };
};
